<router-outlet name="userheader"></router-outlet> <!--  admin haeder -->
<router-outlet (deactivate)="onDeactivate()"></router-outlet>
<router-outlet name="userfooter"></router-outlet> <!--  admin haeder -->